<!--Used when it is necessary to display a document's information (ie from HomePage)
    Will only display embedded pdf on computer.
-->

<template>
  <mdb-container class="pad" v-if="!loading">
    <mdb-row>
      <mdb-col class="mt-5">
        <mdb-card>
          <mdb-card-header>
            <strong>Document</strong>
          </mdb-card-header>
          <mdb-card-body>
            <mdb-card-title>Title:</mdb-card-title>
            <mdb-card-text>{{document.title}}</mdb-card-text>
            <mdb-card-title>Description:</mdb-card-title>
            <mdb-card-text>{{document.text}}</mdb-card-text>
            <a :href="document.doc_file.meta.download_url">
              <mdb-btn v-if="!loading" class="mb-3 btn-sm" color="primary">Download Document</mdb-btn>
            </a>
            <pdf
              v-if="document.doc_transform"
              :src="document.doc_transform.meta.download_url"
              width="1000"
              height="1000"
            ></pdf>
            <pdf v-else :src="document.doc_file.meta.download_url" width="1000" height="1000"></pdf>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardHeader,
  mdbCardBody,
  mdbCardText,
  mdbCardTitle,
  mdbBtn,
} from "mdbvue";
import axios from "axios";
import api from "@/api";
import pdf from "vue-pdf";
export default {
  name: "document",
  props: {
    slug: String,
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardText,
    mdbCardTitle,
    mdbBtn,
    pdf,
  },
  data() {
    return {
      document: String,
      loading: true,
    };
  },
  mounted() {
    axios;
    api
      .get("pages/" + this.slug)
      .then((response) => {
        this.document = response.data;
      })
      .catch((e) => {
        this.errors.push(e);
      })
      .finally(() => (this.loading = false));
  },
};
</script>

<style scoped>
.pad {
  padding-top: 65px;
}
</style>